import { makeAuthenticatedRequest } from "./api";

export const getTopicsMastery = async (classroomId, studentId) => {
  try {
    const URL = `/topics/${classroomId}/mastery${
      studentId ? `?studentId=${studentId}` : ""
    }`;
    return await makeAuthenticatedRequest(
      URL,
      "GET",
      null
    )
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return { ok: true, data: data };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching topics mastery:", error);
    return { ok: false, error: error };
  }
};

export const getTopicsMasteryBySubjects = async (
  classroomId,
  subjectIds,
  studentId
) => {
  try {
    const subjectIdsParam = Array.isArray(subjectIds)
      ? subjectIds.join(",")
      : subjectIds;
    const URL = `/topics/${classroomId}/mastery?subjectId=${subjectIdsParam}${
      studentId ? `&studentId=${studentId}` : ""
    }`;
    return await makeAuthenticatedRequest(
      URL,
      "GET",
      null
    )
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return { ok: true, data: data };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching topics mastery by subjects:", error);
    return { ok: false, error: error };
  }
};
